<template>
<v-speed-dial
  v-model="speed_dial"
  bottom
  right
  style="position: fixed; bottom: 72px"
  :open-on-hover="!is_touch"
>
    <template v-slot:activator>
        <v-fab-transition>
            <v-btn
              fab
              :key="'fab' + locked"
              :small="!$vuetify.breakpoint.mdAndUp"
              :color="speed_dial ? 'secondary' : (locked ? 'secondary' : 'primary')"
              :class="{'shake animated': shake}"
            >
                <v-progress-circular
                  v-if="executing"
                  indeterminate
                />
                <v-icon v-else-if="speed_dial">close</v-icon>
                <v-icon v-else-if="locked">lock</v-icon>
                <v-badge
                  color="none"
                  :offset-x="$vuetify.breakpoint.mdAndUp ? 16 : 18.5"
                  :offset-y="$vuetify.breakpoint.mdAndUp ? 3 : 5.5"
                  v-else
                >
                    <template #badge>
                        <v-icon
                          v-show="dirty"
                          :style="{transform: !$vuetify.breakpoint.mdAndUp ? 'scale(0.7)' : ''}"
                        >
                            star
                        </v-icon>
                    </template>
                    <v-icon>lock_open</v-icon>
                </v-badge>
            </v-btn>
        </v-fab-transition>
    </template>
    <template v-if="!locked">
        <v-btn
          @click="$emit('lock')"
          fab
          small
          color="secondary"
          :disabled="dirty"
        >
            <v-icon>lock</v-icon>
        </v-btn>
        <v-btn
          @click="$emit('save')"
          fab
          small
          color="success"
          :disabled="!dirty"
        >
            <v-icon>save</v-icon>
        </v-btn>
        <v-btn
          @click="$emit('undo')"
          fab
          small
          color="error"
          :disabled="!dirty"
        >
            <v-icon>undo</v-icon>
        </v-btn>
        <slot name="actions-unlocked" />
    </template>
    <template v-else>
        <v-btn
          fab
          small
          color="primary"
          @click="$emit('unlock')"
        >
            <v-icon>lock_open</v-icon>
        </v-btn>
        <slot name="actions-locked" />
    </template>
</v-speed-dial>
</template>

<script>
export default {
    name: 'LockSpeedDial',

    props: {
        locked: {
            type: Boolean,
            default: true
        },
        executing: {
            type: Boolean,
            default: false
        },
        dirty: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            speed_dial: false,
            shake: false,
        }
    },
    computed: {
        is_touch () {
            return 'ontouchstart' in window;
        }
    },
    methods: {
        shake_fab () {
            if (!this.shake){
                this.shake = true
                var self = this
                setTimeout(function () {
                    self.shake = false
                }, 1500)
            }
        },
    }
}
</script>
